import { defineMessages } from 'react-intl'

const scope = 'pages.dashboard'

export default defineMessages({
  dashboardTitle: {
    id: `${scope}.dashboardTitle`,
    defaultMessage: 'Dashboard'
  },
  addReferralBtn: {
    id: `${scope}.addReferralBtn`,
    defaultMessage: 'Add a new Referral +'
  },
  readyReferrals: {
    id: `${scope}.readyReferrals`,
    defaultMessage: 'Completed referrals'
  },
  pendingReferrals: {
    id: `${scope}.pendingReferrals`,
    defaultMessage: 'Pending referrals'
  },
  completedReferrals: {
    id: `${scope}.completedReferrals`,
    defaultMessage: 'Completed referrals'
  },
  scheduledReferrals: {
    id: `${scope}.scheduledReferrals`,
    defaultMessage: 'Scheduled referrals'
  },
  clinics: {
    id: `${scope}.clinics`,
    defaultMessage: 'Clinics'
  },
  newReferrals: {
    id: `${scope}.newReferrals`,
    defaultMessage: 'New referrals'
  }
})
